"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffluentSump = void 0;
const EffluentPond_1 = require("./EffluentPond");
const typeName = 'EffluentSump';
class EffluentSump extends EffluentPond_1.EffluentPond {
    constructor(ob) {
        super({ ...ob, type: typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.EffluentSump = EffluentSump;
